import {useMemo} from 'react';

import type {
  IUseProductionPlanSubStepParams,
  IUseProductionPlanSubStepResult,
} from '../productionInfo.types';

export function lshUseProductionPlanSubStep({
  productionPlanCropOptions,
  productionPlanInitialRecords,
  productionPlanRows,
}: IUseProductionPlanSubStepParams): IUseProductionPlanSubStepResult {
  const productionPlanCropNameById = useMemo(() => {
    const map = new Map<string, string>();

    productionPlanCropOptions.forEach((option) => {
      map.set(option.id, option.name);
    });

    productionPlanInitialRecords.forEach((record) => {
      const cropIdRaw = record?.crop?.id;
      if (cropIdRaw === undefined || cropIdRaw === null) return;
      const key = String(cropIdRaw);
      if (!map.has(key)) {
        map.set(key, String(record?.crop?.name || '').trim() || 'Unknown crop');
      }
    });

    return map;
  }, [productionPlanCropOptions, productionPlanInitialRecords]);

  const selectedProductionPlanCropIds = useMemo(
    () => new Set(productionPlanRows.map((row) => row.cropId)),
    [productionPlanRows],
  );

  const addableProductionPlanCropOptions = useMemo(
    () =>
      productionPlanCropOptions.filter(
        (option) => !selectedProductionPlanCropIds.has(option.id),
      ),
    [productionPlanCropOptions, selectedProductionPlanCropIds],
  );

  return {
    productionPlanCropNameById,
    addableProductionPlanCropOptions,
  };
}
